module.exports = __webpack_public_path__ + "static/media/coveralls.371b34dc.jpg";